export default __webpack_public_path__ + "static/dark blue flower-9c448830bbd3359ff0b0a9e94f7a8785.png";